export default __webpack_public_path__ + "static/media/kitchen3-afterC-1920w.2124bbfd.avif";